'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import { localStore } from 'utils/localStorage';
// import { push } from 'react-router-redux';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _lodash = require('lodash');

var _support = require('helpers/support');

var _PCard = require('../Common/PCard');

var _PCard2 = _interopRequireDefault(_PCard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Tabs, Tab } from 'react-bootstrap';
var ManagePromotion = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    promotions: state.voucher.promotions,
    promotionLoaded: state.voucher.promotionLoaded
  };
}, (0, _extends3.default)({}, vouchersAction)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ManagePromotion, _Component);

  function ManagePromotion() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ManagePromotion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ManagePromotion.__proto__ || (0, _getPrototypeOf2.default)(ManagePromotion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      promotions: _this.props.promotions
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ManagePromotion, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.promotionLoaded) {
        this.props.getAllCoupon();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.promotions, nextProps.promotions)) {
        this.setState({ promotions: nextProps.promotions });
      }
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(campaign) {
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card',
        label: '' + campaign.code
      });
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this2 = this;

      var styles = require('./NewPromotion.scss');
      var promotions = this.state.promotions;

      return _react2.default.createElement(
        'div',
        { className: styles.vSection },
        _react2.default.createElement(
          'div',
          { className: styles.lists },
          promotions.length && promotions.map(function (v, i) {
            return _react2.default.createElement(_PCard2.default, {
              key: 'promotion_' + i,
              className: styles.PCard,
              card: (0, _support.promoData)(v),
              history: _this2.props.history,
              onClick: _this2.onItemClick.bind(_this2)
            });
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./NewPromotion.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.voucher },
        _react2.default.createElement(
          'div',
          { className: styles.tabContent },
          this.renderList()
        )
      );
    }
  }]);
  return ManagePromotion;
}(_react.Component), _class2.propTypes = {
  history: _react.PropTypes.object,
  promotions: _react.PropTypes.array,
  promotionLoaded: _react.PropTypes.bool,
  getAllCoupon: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = ManagePromotion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/ManagePromotion/NewPromotion.js
// module id = 1612
// module chunks = 0